module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-02-iphone-content.bed1ced6.png";